import drawSVG from '../vendor/DrawSVGPlugin';

export default class navigationMobile {

  constructor(el) {

    // GSAP default easing
    gsap.defaults({
      ease: "power4.out",
      duration: 0.4
    });

    // Variables
    this.$body = document.body;
    this.$header = el;
    this.$mobileSwitch = document.getElementById('mobileSwitch');

    // Master Timeline
    this.masterTL = gsap.timeline({
      onStart: () => {
        gsap.set(this.$body, {
          overflow: 'hidden'
        });
      },
      onReverseComplete: () => {
        gsap.set(this.$body, {
          overflow: 'auto'
        });
      }
    });
    this.masterTL.add(this.getMobileNavTL(), "a");
    this.masterTL.add(this.getMobileCtaTL(), "a");
    this.masterTL.add(this.getMobileSwitchTL(), "a");
    this.masterTL.reverse();

    // Events
    this.handleEvents();
  }

  handleEvents() {

    // Toggle mobile switch button and navigation
    this.$mobileSwitch.addEventListener('click', () => {
      if (!this.masterTL.isActive()) {
        // Only reverse the direction if the tween is not active
        this.masterTL.reversed() ? this.open() : this.close();
      }
    });
  }


  // Initialize navigation Timeline
  getMobileNavTL() {

    // Variables
    const
      $nav = this.$header.querySelector('.nav'),
      $items = this.$header.querySelectorAll('.nav__item'),
      tl = gsap.timeline();

    // Timeline
    tl.set($nav, {
      display: 'flex'
    })
    tl.from($nav, {
      y: "-=8",
      opacity: 0,
    });
    tl.from($items, {
      x: "-=8",
      opacity: 0,
      stagger: 0.1
    }, "-=0.2");

    return tl;
  }


  // Initialize navigation Timeline
  getMobileCtaTL() {

    // Variables
    const
      $cta = this.$header.querySelector('.cta-nav'),
      tl = gsap.timeline();

    // Timeline
    tl.set($cta, {
      display: 'flex'
    })
    tl.from($cta, {
      y: "+=8",
      opacity: 0,
    });

    return tl;
  }



  // Initialize mobile switch Timeline
  getMobileSwitchTL() {

    // Avoid tree shaking error in production build
    const plugins = [drawSVG];
    gsap.registerPlugin(drawSVG);

    // Show mobile switch when ready
    gsap.to(this.$mobileSwitch, {
      opacity: 1,
    });

    // Variables
    const
      navBtnSvg = this.$mobileSwitch.querySelector('#mobileSwitchSVG'),
      burger = navBtnSvg.querySelectorAll('#burger line'),
      closeUp = navBtnSvg.querySelector('#close line#up'),
      closeDown = navBtnSvg.querySelector('#close line#down'),
      tl = gsap.timeline();

    // Timeline
    tl.fromTo(burger, {
      x: "0",
      drawSVG: "0% 100%"
    }, {
      // duration: 0.4,
      x: "+=10",
      drawSVG: "0% 0%",
      stagger: 0.1
    });
    tl.fromTo(closeDown, {
      x: "-=10",
      y: "-=10",
      drawSVG: "100% 100%"
    }, {
      // duration: 0.4,
      x: "0",
      y: "0",
      drawSVG: "0% 100%"
    }, "-=0.4");
    tl.fromTo(closeUp, {
      x: "-=10",
      y: "+=10",
      drawSVG: "100% 100%"
    }, {
      // duration: 0.4,
      x: "0",
      y: "0",
      drawSVG: "0% 100%"
    }, "-=0.4");

    return tl;
  }


  // Open mobile navigation
  open() {
    this.masterTL.play();
  }

  // Close mobile navigation
  close() {
    this.masterTL.reverse();
  }

}
